<ng-container *transloco="let convert;">
  <div class="collapse-card-container">
    <button
      class="button-collapse"
      [attr.aria-label]="convert('common.ariaLabelToggleCollapse')"
      (click)="collapse.emit(!collapsed)"
      data-track-elem="accordion"
      [attr.data-track-name]="collapsed ? 'Expand' : 'Collapse'"
      data-track-trigger="statechange"
      [attr.data-track-state]="collapsed ? 'closed' : 'opened'"
      [attr.aria-expanded]="!collapsed"
      >
      @if (!collapsed) {
        <img
          src="../../../ui/assets/assets-{{ tenantName }}/{{ tenantName }}-collapse.svg"
          alt="{{convert('common.altcollapse')}}"
          />
      }
      @if (collapsed) {
        <img src="../../../ui/assets/assets-{{ tenantName }}/{{ tenantName }}-expand.svg" alt="{{convert('common.altexpand')}}" />
      }
    </button>
  </div>
</ng-container>